<span style="position: absolute; z-index: -1; visibility: hidden;">{{ environment }}</span>
<router-outlet></router-outlet>